<template>
    <div class="d-flex flex-column container justify-content-center" style="min-height: 100vh;">
        <div class="d-flex flex-column card p-3" v-if="!tempoExpirado">
            <div class="mx-auto p-3 bg-dark mb-3 d-flex">
                <img src=".././../assets/logo.png" alt="logo" class="w-50 mx-auto">
            </div>
            <p>
                *Após 5 minutos será necessário realizar uma nova solicitação para redefinir sua senha.
            </p>
            <div class="d-flex card gap-sm p-3">
                <div class="d-flex flex-column">
                    <label>Código:</label>
                    <b-input placeholder="Digite o código" v-model="codigo"/>
                </div>
                <div class="d-flex flex-column">
                    <label>Senha:</label>
                <b-input-group>
                    <b-form-input v-model="senha" :type="typeInputSenha" placeholder="Digite sua nova senha"></b-form-input>
                    <b-input-group-append>
                        <b-button variant="outline-secondary" @click="handleMostrarSenha()">
                            <font-awesome-icon :icon="iconesMostrarSenha" />
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
                </div>
                <div class="d-flex flex-column">
                    <label>Confirme Nova Senha:</label>
                <b-input-group>
                    <b-form-input v-model="confimacaoSenha" :type="typeInputConfirmeSenha" placeholder="Digite sua confirmação de senha"></b-form-input>
                    <b-input-group-append>
                        <b-button variant="outline-secondary" @click="handleMostrarConfirmeSenha()">
                            <font-awesome-icon :icon="iconesMostrarCofirmeSenha" />
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
                </div>
                <div class="d-flex w-100 justify-content-end">
                    <b-button variant="success" @click="redefinirSenha()" :disabled="carregando">
                        <b-spinner variant="white" v-if="carregando"></b-spinner>
                        <span v-if="!carregando">
                            Enviar
                        </span>
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthService from "../../service/AuthService.js";

export default{
	name: "RedefinirSenhaViaEsqueciMinhaSenha",
	data() {
		return {
			iconesMostrarSenha: "fa-solid fa-eye",
			iconesMostrarCofirmeSenha: "fa-solid fa-eye",
			typeInputSenha: "password",
			typeInputConfirmeSenha: "password",

			codigo: "",
			senha: "",
			confimacaoSenha: "",

			tempoExpirado: false,
		};
	},
	created() {
		this.recuperaHashDaUrl();
	},
	methods: {
		async mostrarMsgBoxSucesso() {
			await this.$bvModal.msgBoxOk("A senha foi alterada com sucesso.", {
				title: "Sucesso!",
				size: "sm",
				buttonSize: "sm",
				okVariant: "success",
				centered: true,
			});
		},
		async mostrarMsgBoxTempoExpirado() {
			await this.$bvModal.msgBoxOk("O link de redefinição de senha expirou, por favor realize uma nova solicitação de redefinição de senha.", {
				title: "Link Expirado!",
				size: "sm",
				buttonSize: "sm",
				okVariant: "secondary",
				centered: true,
			});
		},
		recuperaHashDaUrl() {
			const { hash } = this.$route.query;
			const dataLimite = this.$options.filters.moment(atob(hash));
			const agora = this.$options.filters.moment();
			if (agora.isAfter(dataLimite) || !hash) {
				this.tempoExpirado = true;
				this.mostrarMsgBoxTempoExpirado().finally(() => this.$router.push("/login"));
			}
		},
		redefinirSenha() {
			const form = {
				codigo: this.codigo,
				novaSenha: this.senha,
				confirmacaoNovaSenha: this.confimacaoSenha,
			};
			this.carregando = true;

			AuthService.redefinirSenhaViaEsqueciMinhaSenha(form)
				.then(() => {
					this.mostrarMsgBoxSucesso().finally(() => this.$router.push("/login"));
				})
				.catch((err) => {
					console.log(err);
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível redefinir a senha nesse momento, por favor tente novamente mais tarde", "Erro", "danger");
					}
				}).finally(() => {
					this.carregando = false;
				});
		},
		handleMostrarSenha() {
			if (this.typeInputSenha == "password") {
				this.typeInputSenha = "text";
				this.iconesMostrarSenha = "fa-solid fa-eye-slash";
			} else {
				this.typeInputSenha = "password";
				this.iconesMostrarSenha = "fa-solid fa-eye";
			}
		},
		handleMostrarConfirmeSenha() {
			if (this.typeInputConfirmeSenha == "password") {
				this.typeInputConfirmeSenha = "text";
				this.iconesMostrarCofirmeSenha = "fa-solid fa-eye-slash";
			} else {
				this.typeInputConfirmeSenha = "password";
				this.iconesMostrarCofirmeSenha = "fa-solid fa-eye";
			}
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},

};
</script>



// WEBPACK FOOTER //
// src/views/outros/RedefinirSenhaViaEsqueciMinhaSenha.vue